module.exports = __webpack_public_path__ + "static/media/spade.424b52b9.svg";